const SEM_HOME_DIRECTORY = "sem-home";

const getCdnBaseUrl = (): string => {
  // Explicit override — used in local dev to point at a live environment.
  const explicitCdnUrl = process.env.NEXT_PUBLIC_CDN_URL;
  if (explicitCdnUrl) return explicitCdnUrl.replace(/\/+$/, "");

  const domain = process.env.NEXT_PUBLIC_DOMAIN;
  if (!domain) return "";

  const protocol = process.env.NEXT_PUBLIC_HTTP_PROTOCOL || "https";
  return `${protocol}://${domain}`;
};

/**
 * Builds an absolute URL for a static asset hosted on the S3/CDN layer.
 *
 * @param assetPath Path of the asset within the bucket (a leading slash is optional).
 */
export const cdnAsset = (assetPath: string): string => {
  const normalizedPath = assetPath.replace(/^\/+/, "");
  return `${getCdnBaseUrl()}/${normalizedPath}`;
};

/**
 * Builds the CDN URL for a SEM home asset. These assets are
 * served under the `/sem-home/` prefix of the bucket.
 *
 * @param assetPath Path of the asset relative to the `sem-home` directory.
 */
export const semHomeAsset = (assetPath: string): string =>
  cdnAsset(`${SEM_HOME_DIRECTORY}/${assetPath.replace(/^\/+/, "")}`);

const getActiveTheme = (): string => process.env.NEXT_PUBLIC_THEME ?? "";

/**
 * Builds the CDN URL for a SEM home asset that is theme-specific. The asset is namespaced
 * under the active theme: `/sem-home/<theme>/<file>` — each site keeps its
 * own visuals while sharing a single bucket.
 *
 * @param assetPath Path of the asset relative to the theme directory.
 */
export const semHomeThemeAsset = (assetPath: string): string =>
  semHomeAsset(`${getActiveTheme()}/${assetPath.replace(/^\/+/, "")}`);
